import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, IconButton } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import SimpleTooltip from '../../../../SimpleTooltip';
import { TableStateContext } from '../../TableStateContext';
import { triggerCSVDownload } from '../../../../../providers/CSVDownloadSubWrapper';
import { insertAfterProperty } from '../../../../../utils/appUtils';

export const CsvDownloadButton = ({ ...props }) => {
  // @ts-expect-error TS(2339): Property 'tableId' does not exist on type 'unknown... Remove this comment to see the full error message
  const { tableId, columns, rows } = React.useContext(TableStateContext);
  return (
    <CsvDownloadButtonBase
      {...props}
      tableId={tableId}
      columns={Object.values(columns)}
      data={rows}
    />
  );
};

export const CustomCsvDownloadButton = ({
  overrideColumns,
  overrideData,
  ...props
}: any) => {
  // @ts-expect-error TS(2339): Property 'tableId' does not exist on type 'unknown... Remove this comment to see the full error message
  const { tableId, columns, rows = [] } = React.useContext(TableStateContext);

  let processedColumns = { ...columns };
  // add override columns to the columns object in sequence
  Object.keys(overrideColumns).forEach((key) => {
    const column = overrideColumns[key];
    if (columns[column.dependentColumn].show !== false) {
      processedColumns = insertAfterProperty(
        column.dependentColumn,
        key,
        column,
        processedColumns
      );
    }
  });

  const processedRows = rows.map((row: any) => ({
    ...row,
    ...overrideData(row),
  }));

  return (
    <CsvDownloadButtonBase
      {...props}
      tableId={tableId}
      columns={Object.values(processedColumns)}
      data={processedRows}
    />
  );
};

const CsvDownloadButtonBase = ({ ...props }) => {
  const theme = useTheme();

  const onStartDownload = () =>
    triggerCSVDownload({
      columns: props.columns,
      data: props.data,
      filename: props.csvDownloadTitle || props.tableId,
    });

  return (
    <IconButton
      onClick={onStartDownload}
      size="small"
      style={{
        cursor: 'pointer',
        color: theme.palette.text.primary,
        marginLeft: '0.4rem',
      }}
    >
      <SimpleTooltip title="Download Table as CSV file">
        <GetAppIcon
          style={{ fontSize: '2rem', position: 'relative', right: 1 }}
          color="primary"
        />
      </SimpleTooltip>
    </IconButton>
  );
};
CustomCsvDownloadButton.propTypes = {
  overrideColumns: PropTypes.object,
  overrideData: PropTypes.func,
};

export default CsvDownloadButtonBase;
